export type NormalizedPaidCallResult = {
  orderId: string;
  productName: string;
  serviceStatus: number;
  result: unknown;
  calledAt: string;
};

function recordValue(value: unknown): Record<string, unknown> | undefined {
  return value !== null && typeof value === "object"
    ? value as Record<string, unknown>
    : undefined;
}

function nonEmptyString(value: unknown): string | undefined {
  return typeof value === "string" && value.trim() ? value : undefined;
}

export function normalizePaidCallResponse(
  response: unknown,
  fallbackProductName: string,
): NormalizedPaidCallResult {
  const body = recordValue(response);
  const orderId = nonEmptyString(body?.orderId);
  const calledAt = nonEmptyString(body?.calledAt);
  if (!body || !orderId || !calledAt) {
    throw new Error("服务已支付，但成功响应格式不完整，请在钱包管理中心查看订单。");
  }

  const product = recordValue(body.product);
  if (product) {
    return {
      orderId,
      productName: nonEmptyString(product.name) || fallbackProductName,
      serviceStatus: typeof body.serviceStatus === "number" ? body.serviceStatus : 200,
      result: body.result,
      calledAt,
    };
  }

  const subscription = recordValue(body.subscription);
  if (subscription) {
    const activationCallback = recordValue(body.activationCallback);
    return {
      orderId,
      productName: nonEmptyString(subscription.productName) || fallbackProductName,
      serviceStatus: typeof activationCallback?.httpStatus === "number"
        ? activationCallback.httpStatus
        : 200,
      result: {
        subscription: body.subscription,
        activationCallback: body.activationCallback,
      },
      calledAt,
    };
  }

  throw new Error("服务已支付，但成功响应格式不完整，请在钱包管理中心查看订单。");
}
